$ = jQuery.noConflict(),
body = $('body'),
head = $('#masthead'),
remsize = parseFloat($('html').css('font-size'));

// This little function adds a CSS var with the pre-shift VH height on mobiles
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);


function watchForHover() {
    // lastTouchTime is used for ignoring emulated mousemove events
    let lastTouchTime = 0
  
    function enableHover() {
      if (new Date() - lastTouchTime < 500) return
      document.body.classList.add('hashover')
    }
  
    function disableHover() {
      document.body.classList.remove('hashover')
    }
  
    function updateLastTouchTime() {
      lastTouchTime = new Date()
    }
  
    document.addEventListener('touchstart', updateLastTouchTime, true)
    document.addEventListener('touchstart', disableHover, true)
    document.addEventListener('mousemove', enableHover, true)
  
    enableHover()
  }


function alright_barb() {
  if($('#mwm-transition').length < 1) return;
  console.log('found it');

  barba.init({
    transitions: [{
      name: 'default-transition',
      leave() {
        console.log('leave');
        $('#mwm-transition').find('.slide-1').css('transform-origin','left').css('transform', 'scaleX(1)');
        $(window).scrollTop(0);
      },
      enter() {
        // create your amazing enter animation here
        
        console.log('enter');
        $('#mwm-transition').find('.slide-1').css('transform-origin','right').css('transform', 'scaleX(0)');
      }
    }]
  });

  // UPDATE BODY CLASSES ON TRANSITION
  barba.hooks.afterLeave((data) => {
    // Set <body> classes for "next" page
    var nextHtml = data.next.html;
    var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml)
    var bodyClasses = $(response).filter('notbody').attr('class')
    $("body").attr("class", bodyClasses);
  });
}


function countUpNumber(element) {
  const $element = $(element);
  const textContent = $element.text().trim();

  const numberMatch = textContent.match(
    /(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?/
  );

  if (!numberMatch) return;

  const rawNumber = numberMatch[0];
  const number = parseFloat(rawNumber.replace(/,/g, ''));

  const prefix = textContent.substring(0, numberMatch.index).trim();
  const suffix = textContent
    .substring(numberMatch.index + rawNumber.length)
    .trim();

  $element.html(`
    ${prefix ? `<span class="count-prefix">${prefix}</span>` : ''}
    <span class="count"></span>
    ${suffix ? `<span class="count-suffix">${suffix}</span>` : ''}
  `);

  const countElement = $element.find('.count')[0];

  // Measure final width first to prevent layout shift.
  const finalValue = formatNumber(number, rawNumber);

  countElement.textContent = finalValue;
  countElement.style.display = 'inline-block';

  const finalWidth = countElement.getBoundingClientRect().width;

  countElement.style.minWidth = `${finalWidth}px`;
  countElement.textContent = formatNumber(0, rawNumber);

  const duration = 3000;
  const startTime = performance.now();

  function animate(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // Cubic ease-out.
    const easedProgress = 1 - Math.pow(1 - progress, 3);

    const currentValue = number * easedProgress;

    countElement.textContent = formatNumber(currentValue, rawNumber);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      countElement.textContent = finalValue;
    }
  }

  requestAnimationFrame(animate);
}

function formatNumber(value, originalNumber) {
  const decimalMatch = originalNumber.match(/\.(\d+)/);
  const decimals = decimalMatch ? decimalMatch[1].length : 0;

  return value.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

function paper_parallax() {
  return;
  var papers = $('.background-paper');
    papers.each(function() {
      $(this).attr('uk-parallax', 'bgy: 35%;'); // Adjust values as needed
    });
}




  $( document ).ready(function() {



$darthfav = $('#darth-favicon').attr('href');
$originfav = $('#favicon').attr('href');

$(window).focus(function(){
  $('#favicon').attr('href', $originfav );
});

$(window).blur(function(){
  $('#favicon').attr('href', $darthfav);
});

alright_barb();

paper_parallax();

    UIkit.mixin({
      data: {
          easing: 0,
      }
  }, 'parallax');


    var didScroll;
  var lastScrollTop = 0,
      scrollAmount = 0;
  var delta = 5;
  // on scroll, let the interval function know the user has scrolled
  $(window).on('scroll', function(event){
    didScroll = true;
  });
  // run hasScrolled() and reset didScroll status
  setInterval(function() { 
    if (didScroll) {
      var st = $(window).scrollTop(),
          head = $('#masthead'),
          body = $('body'),
          pagehead = $('#page > .page-header');

      if(Math.abs(lastScrollTop - st) <= delta)
              return;

        st < pagehead.outerHeight() ? body.removeClass('scrolled') : body.addClass('scrolled');
        
        console.log('scrollllllltest');

        if(st > lastScrollTop || st < head.outerHeight()) {
          head.removeClass('up');
          scrollAmount = 0;
          
        } else {

          head.addClass('up');
        }
        
  //console.log(scrollAmount);
  lastScrollTop = st;

      didScroll = false;
    }
  }, 250);
  
  watchForHover();

  // Setup infinite scroll for WooCommerce archive
  setupWooInfiniteScroll();
  initAvatarUpload();
  initFundraiserUpdateForm();
  initFundraiserSteps();
  initSponsorshipForm();
  initFundraiserDonateModal();
  initFundraiserDonationPagination();
  initAuthFlow();
  initShareLinks();
  initCheckoutGiftAidToggle();
  initFundraiserNoEditLock();

      function setupWooInfiniteScroll() {
      var container = $('.shop-content > ul.products');
      console.log('hello 1')
      
      // Check if container and trigger exist
      var trigger = $('.page-load-status');
      
      if (trigger.length < 1 || container.length < 1) return;
      console.log('hello 2')
      var nextLink = $('.woocommerce-pagination .next').attr('href') || '';
      
      UIkit.util.on(trigger[0], 'inview', function () {
        console.log('hello 3')
        // Prevent multiple triggers
        if (trigger.hasClass('loading')) return;
        if (!nextLink) {
          trigger.hide(); // No more pages
          return;
        }
        trigger.addClass('loading');
        
        console.log('hello 4')
        console.log('hello 5')
        
        $.post(mwmAjax.ajaxurl, {
          action: 'mwm_load_shop_products',
          nonce: mwmAjax.shopInfiniteNonce,
          next_url: nextLink
        }).done(function (response) {
          var data = response && response.data ? response.data : {};
          var newItems = $(data.html || '');
          console.log('hello 6', response);
          
          if (newItems.length) {
                console.log('hello 7');
                container.append(newItems);
                nextLink = data.next_url || '';
                $('.woocommerce-pagination .next').attr('href', nextLink);
                if (!nextLink) trigger.fadeOut('slow');
              } else {
                  console.log('hello 8')
                  nextLink = '';
                  trigger.fadeOut('slow'); // No more items
              }
          }).fail(function () {
            console.log('Infinite scroll request failed');
          }).always(function () {
            trigger.removeClass('loading');
          });
      });
  }

  function initFundraiserNoEditLock() {
    var onFundraisersEndpoint = body.hasClass('woocommerce-account');
    if (!onFundraisersEndpoint) {
      return;
    }

    $(document).on('click', 'a[href="#noedits"]', function (event) {
      event.preventDefault();
      console.log('edit click');
      alert('Your fundraiser is live and can no longer be edited. To request changes, please contact events@cinnamon.org.uk or call us on 01736 757 900');
    });
  }

  function initAvatarUpload() {
    var $uploads = $('.js-avatar-upload');
    if ($uploads.length < 1) return;

    $uploads.each(function() {
      var $drop = $(this);
      var $input = $drop.find('input[type="file"]');
      var $label = $($drop.data('upload-label'));

      if ($label.length < 1) {
        $label = $drop.find('.js-upload-filename');
      }

      function updateLabel(files) {
        if (!files || files.length < 1) {
          $label.text('No file selected');
          return;
        }

        var names = [];
        for (var i = 0; i < files.length; i++) {
          names.push(files[i].name);
        }
        $label.text(names.join(', '));
      }

      $input.on('change', function() {
        updateLabel(this.files);
      });

      $drop.on('dragenter dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $drop.addClass('uk-dragover');
      });

      $drop.on('dragleave dragend drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $drop.removeClass('uk-dragover');
      });

      $drop.on('drop', function(e) {
        var files = e.originalEvent.dataTransfer.files;
        if (!files || files.length < 1) return;

        try {
          $input[0].files = files;
          $input.trigger('change');
        } catch (err) {
          // Fallback to manual selection if the browser blocks programmatic assignment.
        }
      });
    });
  }

  function initFundraiserUpdateForm() {
    var $forms = $('.mwm-fundraiser-update-form');
    if ($forms.length < 1) return;

    $forms.each(function() {
      var $form = $(this);
      var $mediaType = $form.find('input[name="update_media_type"]');
      var $socialWrap = $form.find('[data-update-media-field="social"]');
      var $imageWrap = $form.find('[data-update-media-field="image"]');
      var $socialInput = $form.find('#update_video');
      var $imageInput = $form.find('#update_image');
      var $oembedPreviewWrap = $form.find('[data-update-oembed-preview-wrap]');
      var $oembedPreview = $form.find('[data-update-oembed-preview]');
      var $oembedError = $form.find('[data-update-oembed-error]');
      var $oembedStatus = $form.find('[data-update-oembed-status]');
      var oembedNonce = $form.find('input[name="mwm_fundraiser_update_oembed_nonce"]').val() || '';
      var previewTimer = null;
      var previewRequestId = 0;

      function syncMediaFields() {
        var selected = ($mediaType.filter(':checked').val() || '').toString();
        var showSocial = selected === 'social';
        var showImage = selected === 'image';

        $socialWrap.prop('hidden', !showSocial);
        $imageWrap.prop('hidden', !showImage);

        if (!showSocial) {
          clearOembedUi();
        } else {
          scheduleOembedPreview();
        }
      }

      function clearOembedUi() {
        if ($oembedPreview.length) {
          $oembedPreview.empty();
        }
        if ($oembedPreviewWrap.length) {
          $oembedPreviewWrap.addClass('uk-hidden');
        }
        if ($oembedError.length) {
          $oembedError.addClass('uk-hidden').text('');
        }
        if ($oembedStatus.length) {
          $oembedStatus.addClass('uk-hidden').text('');
        }
      }

      function setOembedError(message) {
        clearOembedUi();
        if ($oembedError.length) {
          $oembedError.removeClass('uk-hidden').text(message || 'This link could not be embedded.');
        }
      }

      function setOembedChecking() {
        if ($oembedError.length) {
          $oembedError.addClass('uk-hidden').text('');
        }
        if ($oembedPreview.length) {
          $oembedPreview.empty();
        }
        if ($oembedPreviewWrap.length) {
          $oembedPreviewWrap.removeClass('uk-hidden');
        }
        if ($oembedStatus.length) {
          $oembedStatus.removeClass('uk-hidden').text('Checking embed...');
        }
      }

      function socialModeSelected() {
        return (($mediaType.filter(':checked').val() || '').toString() === 'social');
      }

      function currentSocialUrl() {
        return (($socialInput.val() || '').toString()).trim();
      }

      function requestOembedPreview(url) {
        if (!window.mwmAjax || !mwmAjax.ajaxurl) {
          setOembedError('Preview is unavailable right now. You can still submit if the URL is valid.');
          return;
        }

        setOembedChecking();
        previewRequestId += 1;
        var requestId = previewRequestId;

        $.post(mwmAjax.ajaxurl, {
          action: 'mwm_fundraiser_update_oembed_preview',
          nonce: oembedNonce,
          url: url
        }).done(function(response) {
          if (requestId !== previewRequestId || !socialModeSelected()) return;

          if (!response || !response.success || !response.data || !response.data.html) {
            var err = (response && response.data && response.data.message) ? response.data.message : 'This link could not be embedded.';
            setOembedError(err);
            return;
          }

          if ($oembedError.length) {
            $oembedError.addClass('uk-hidden').text('');
          }
          if ($oembedStatus.length) {
            $oembedStatus.addClass('uk-hidden').text('');
          }
          if ($oembedPreview.length) {
            $oembedPreview.html(response.data.html);
          }
          if ($oembedPreviewWrap.length) {
            $oembedPreviewWrap.removeClass('uk-hidden');
          }
        }).fail(function(xhr) {
          if (requestId !== previewRequestId || !socialModeSelected()) return;

          var fallback = 'This link could not be embedded.';
          var msg = (xhr && xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) ? xhr.responseJSON.data.message : fallback;
          setOembedError(msg);
        });
      }

      function scheduleOembedPreview() {
        if (!socialModeSelected()) {
          clearOembedUi();
          return;
        }

        var url = currentSocialUrl();
        if (!url) {
          clearOembedUi();
          return;
        }

        if (previewTimer) {
          clearTimeout(previewTimer);
        }
        previewTimer = setTimeout(function() {
          requestOembedPreview(url);
        }, 350);
      }

      $form.on('change', 'input[name="update_media_type"]', function() {
        syncMediaFields();
      });

      $form.on('input blur', '#update_video', function() {
        scheduleOembedPreview();
      });

      $form.on('submit', function(e) {
        if (!socialModeSelected()) return;

        var url = currentSocialUrl();
        if (!url) return;

        if ($oembedPreview.find('iframe,blockquote,embed,object').length > 0) {
          return;
        }

        e.preventDefault();
        scheduleOembedPreview();
        setOembedError('Please add a valid embeddable URL before submitting. Our site oEmbed supports links from platforms like YouTube, Vimeo and TikTok.');
        if ($socialInput.length && $socialInput[0].focus) {
          $socialInput[0].focus();
        }
      });

      syncMediaFields();
    });
  }

  function initFundraiserSteps() {
    var $containers = $('[data-fundraiser-steps]');
    if ($containers.length < 1) return;

    var $form = $containers.filter('[data-fundraiser-form]').first();
    var $navRoot = $form.length ? $form : $containers.first();
    var $stepsRef = $form.length ? $form.find('.mwm-step') : $containers.first().find('.mwm-step');
    var index = 0;
    var configuredStartStep = parseInt($form.attr('data-fundraiser-start-step'), 10);
    var hasConfiguredStartStep = !isNaN(configuredStartStep);
    if (hasConfiguredStartStep) {
      index = Math.max(0, Math.min($stepsRef.length - 1, configuredStartStep - 1));
    }

    var $title = $form.find('#fundraiser_title');
    var $goal = $form.find('#fundraiser_goal');
    var $dynamic = $form.find('input[name="fundraiser_dynamic_goal"]');
    var $eventType = $form.find('input[name="evtype"]');
    var $startField = $form.find('[data-fundraiser-start-field]');
    var $startInput = $form.find('#fundraiser_start');
    var $endInput = $form.find('#fundraiser_end');
    var $intro = $form.find('#fundraiser_intro');
    var $story = $form.find('#fundraiser_story');
    var $gallery = $form.find('input[name="fundraiser_gallery[]"]');
    var $reviewTermsConfirm = $form.find('input[name="fundraiser_terms_confirmed"]');
    var $reviewSubmitButton = $form.find('[data-review-submit]');
    var draftStorageKey = 'mwm_fundraiser_login_gate_draft';

    function saveLoginGateDraft() {
      if (!$form.length || !window.sessionStorage) return;
      var payload = {
        title: $title.val() || '',
        goal: $goal.val() || '',
        continueAfterLogin: 1
      };

      try {
        window.sessionStorage.setItem(draftStorageKey, JSON.stringify(payload));
      } catch (err) {
        // Ignore storage failures (private mode, quota, etc).
      }
    }

    function restoreLoginGateDraft() {
      if (!$form.length || !window.sessionStorage) return;

      var raw = '';
      try {
        raw = window.sessionStorage.getItem(draftStorageKey);
      } catch (err) {
        raw = '';
      }

      if (!raw) return;

      var payload;
      try {
        payload = JSON.parse(raw);
      } catch (err) {
        payload = null;
      }

      if (!payload || typeof payload !== 'object') return;

      if (!$title.val() && payload.title) {
        $title.val(payload.title);
      }
      if (!$goal.val() && payload.goal) {
        $goal.val(payload.goal);
      }

      if (!hasConfiguredStartStep && $('body').hasClass('logged-in') && payload.continueAfterLogin) {
        index = 1;
      }

      if ($('body').hasClass('logged-in')) {
        try {
          window.sessionStorage.removeItem(draftStorageKey);
        } catch (err) {
          // Ignore storage failures.
        }
      }
    }

    function openAuthModal() {
      var $authModal = $('#mwm-auth-modal');
      if ($authModal.length && typeof UIkit !== 'undefined' && typeof UIkit.modal === 'function') {
        UIkit.modal($authModal).show();
        return true;
      }
      return false;
    }

    function showStep(i) {
      $containers.each(function() {
        var $localSteps = $(this).find('.mwm-step');
        $localSteps.attr('hidden', true);
        $localSteps.eq(i).removeAttr('hidden');
      });
      syncReviewSubmitState();
    }

    function syncReviewSubmitState() {
      if (!$reviewSubmitButton.length || !$reviewTermsConfirm.length) return;
      $reviewSubmitButton.prop('disabled', !$reviewTermsConfirm.is(':checked'));
    }

    function syncEventTypeFields() {
      if (!$eventType.length || !$startField.length) return;
      var selected = ($eventType.filter(':checked').val() || 'single').toString();
      var showStart = selected === 'multi';
      $startField.prop('hidden', !showStart);
      if (!showStart && $startInput.length) {
        $startInput.val('');
      }
    }

    function escapeHtml(text) {
      return $('<div>').text(text || '').html();
    }

    function renderReview() {
      if (!$form.length) return;
      $form.find('[data-review="fundraiser_title"]').text($title.val() || '—');
      var goalValue = $goal.val();
      $form.find('[data-review="fundraiser_goal"]').text(goalValue ? '£' + goalValue : '—');
      $form.find('[data-review="fundraiser_dynamic_goal"]').text($dynamic.is(':checked') ? 'Yes' : 'No');
      var endValue = ($form.find('#fundraiser_end').val() || $form.find('input[name="fundraiser_end"]').val() || '');
      $form.find('[data-review="fundraiser_end"]').text(endValue || '—');
      var introText = $intro.val() || '—';
      $form.find('[data-review="fundraiser_intro"]').html(escapeHtml(introText).replace(/\n/g, '<br>'));
      var storyText = $story.val() || '—';
      $form.find('[data-review="fundraiser_story"]').html(escapeHtml(storyText).replace(/\n/g, '<br>'));

      if ($gallery.length) {
        var files = selectedFiles.length ? selectedFiles : ($gallery[0].files || []);
        var $existingFeaturedImage = $form.find('[data-feat-exists] img').first();
        var hasExistingFeaturedImage = $existingFeaturedImage.length > 0;
        if ((files && files.length) || featuredFile || hasExistingFeaturedImage) {
          var galleryHtml = '<div style="display:flex;flex-wrap:wrap;gap:6px;">';
          if (featuredFile) {
            var featuredUrl = '';
            try {
              featuredUrl = URL.createObjectURL(featuredFile);
            } catch (err) {
              featuredUrl = '';
            }
            if (featuredUrl) {
              galleryHtml += '<img src="' + featuredUrl + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:4px;" />';
            }
          } else if (hasExistingFeaturedImage) {
            var existingFeaturedUrl = $existingFeaturedImage.attr('src') || '';
            if (existingFeaturedUrl) {
              galleryHtml += '<img src="' + escapeHtml(existingFeaturedUrl) + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:4px;" />';
            }
          }
          for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var url = '';
            try {
              url = URL.createObjectURL(file);
            } catch (err) {
              url = '';
            }
            if (url) {
              galleryHtml += '<img src="' + url + '" alt="" style="width:64px;height:64px;object-fit:cover;border-radius:4px;" />';
            }
          }
          galleryHtml += '</div>';
          $form.find('[data-review="fundraiser_gallery"]').html(galleryHtml);
        } else {
          $form.find('[data-review="fundraiser_gallery"]').text('—');
        }
      }
    }

    function clearStepError() {
      $form.find('.mwm-step-error').remove();
    }

    function showStepError(message) {
      clearStepError();
      if (!message) return;
      var $error = $('<div class="uk-alert-danger mwm-step-error" uk-alert><p></p></div>');
      $error.find('p').text(message);
      $stepsRef.eq(index).prepend($error);
    }

    function hasFeaturedImage() {
      if($('[data-feat-exists]').length) {
        return true;
      }

      if (!$featured.length) {
        return false;
      }
      var $featuredInput = $featured.find('input[type="file"]');
      if ($featuredInput.length && $featuredInput[0].files && $featuredInput[0].files.length) {
        return true;
      }
      if (featuredFile) {
        return true;
      }
      if ($featuredPreview.length && $featuredPreview.find('img').length) {
        return true;
      }

      return false;
    }

    function validateStep() {
      clearStepError();

      if (index === 0) {
        if (!$title.val().trim()) {
          showStepError('Please enter a fundraiser title.');
          $title.focus();
          return false;
        }
        if (!$goal.val().trim()) {
          showStepError('Please enter a fundraiser goal.');
          $goal.focus();
          return false;
        }
      }

      if (index === 2) {
        if (!hasFeaturedImage()) {
          showStepError('Please upload a featured image to continue.');
          return false;
        }
      }

      if (index === 1) {
        if (!$endInput.val().trim()) {
          showStepError('Please choose an event end date.');
          $endInput.focus();
          return false;
        }
      }

      if (index === 3) {
        if (!$intro.val().trim()) {
          showStepError('Please add a short introduction for your fundraiser.');
          $intro.focus();
          return false;
        }
      }

      if (index === 4) {
        if ($reviewTermsConfirm.length && !$reviewTermsConfirm.is(':checked')) {
          showStepError('Please confirm you have read and understood the website terms of use.');
          $reviewTermsConfirm.focus();
          return false;
        }
      }

      return true;
    }

    $form.on('keydown', 'input,textarea', function(e) {
      if (e.key !== 'Enter') {
        return;
      }
      if (this.tagName.toLowerCase() === 'textarea') {
        return;
      }
      if (index < $stepsRef.length - 1) {
        e.preventDefault();
        var $currentNext = $stepsRef.eq(index).find('[data-step-next]').first();
        if ($currentNext.length) {
          $currentNext.trigger('click');
        }
      }
    });

    $form.on('submit', function(e) {
      if (index < $stepsRef.length - 1) {
        e.preventDefault();
        validateStep();
        return false;
      }
      if (!validateStep()) {
        e.preventDefault();
        return false;
      }
    });

    $navRoot.on('click', '[data-step-next]', function(e) {
      e.preventDefault();
      if ($(this).is('[data-step-logincheck]') && !$('body').hasClass('logged-in')) {
        saveLoginGateDraft();

        if (!openAuthModal()) {
          window.location.href = '/wp-login.php?redirect_to=' + encodeURIComponent(window.location.href);
          // #!! This should fallback to MY ACCOUNT not WP Admin login
        }
        return;
      }

      if (!validateStep()) {
        return;
      }

      if (index < $stepsRef.length - 1) {
        index += 1;
        if ($form.length && $form.find('.mwm-step').eq(index).find('[data-review]').length) {
          renderReview();
        }
        showStep(index);
      }
    });

    $navRoot.on('click', '[data-step-prev]', function(e) {
      e.preventDefault();
      if (index > 0) {
        index -= 1;
        showStep(index);
      }
    });

    $navRoot.on('click', '[data-step-jump]', function(e) {
      e.preventDefault();
      var target = parseInt($(this).data('step-jump'), 10);
      if (!isNaN(target)) {
        index = target - 1;
        showStep(index);
      }
    });

    $form.on('change', 'input[name="evtype"]', function() {
      syncEventTypeFields();
    });

    $form.on('change', 'input[name="fundraiser_terms_confirmed"]', function() {
      syncReviewSubmitState();
      clearStepError();
    });

    var selectedFiles = [];
    var featuredFile = null;
    var $drop = $form.find('.js-fundraiser-gallery-upload');
    var $label = $($drop.data('upload-label'));
    var $list = $form.find('[data-upload-list]');
    var $featured = $form.find('.js-fundraiser-featured-upload');
    var $featuredLabel = $featured.length ? $($featured.data('upload-label')) : $();
    var $featuredPreview = $featured.length ? $($featured.data('preview')) : $();

    function syncInput() {
      var input = $drop.find('input[type="file"]')[0];
      if (!input) return;

      if (!selectedFiles.length) {
        input.value = '';
        return;
      }

      try {
        var dt = new DataTransfer();
        selectedFiles.forEach(function(file) {
          dt.items.add(file);
        });
        input.files = dt.files;
      } catch (err) {
        // If DataTransfer isn't available, fallback to the browser-managed list.
      }
    }

    function renderList() {
      if (!$label.length) return;
      if (!selectedFiles.length) {
        $label.text('No files selected');
        if ($list.length) $list.empty();
        return;
      }

      var names = selectedFiles.map(function(file) { return file.name; });
      $label.text(names.join(', '));

      if ($list.length) {
        $list.empty();
        selectedFiles.forEach(function(file, idx) {
          var previewUrl = '';
          try {
            previewUrl = URL.createObjectURL(file);
          } catch (err) {
            previewUrl = '';
          }
          $list.append(
            '<li class="uk-flex uk-flex-between uk-flex-middle">' +
              '<span class="uk-flex uk-flex-middle">' +
                (previewUrl ? '<img src="' + previewUrl + '" alt="" style="width:48px;height:48px;object-fit:cover;margin-right:10px;border-radius:4px;" />' : '') +
                '<span>' + file.name + '</span>' +
              '</span>' +
              '<button type="button" class="uk-button uk-button-text" data-remove-upload="' + idx + '">Remove</button>' +
            '</li>'
          );
        });
      }
    }

    function addFiles(files) {
      if (!files || !files.length) return;
      var maxFiles = parseInt($drop.data('max-files'), 10);
      var max = isNaN(maxFiles) ? files.length : maxFiles;

      for (var i = 0; i < files.length; i++) {
        if (selectedFiles.length >= max) break;
        selectedFiles.push(files[i]);
      }

      if (selectedFiles.length > max) {
        selectedFiles = selectedFiles.slice(0, max);
      }

      syncInput();
      renderList();
    }

    function setFeaturedFile(file) {
      if (!$featured.length) return;
      var $featuredInput = $featured.find('input[type="file"]');
      if (!$featuredInput.length) return;

      if (!file) {
        featuredFile = null;
        $featuredInput.val('');
        if ($featuredLabel.length) $featuredLabel.text('No file selected');
        if ($featuredPreview.length) $featuredPreview.empty();
        return;
      }

      featuredFile = file;
      if ($featuredLabel.length) $featuredLabel.text(file.name);

      try {
        var dtFeatured = new DataTransfer();
        dtFeatured.items.add(file);
        $featuredInput[0].files = dtFeatured.files;
      } catch (err) {
        // If DataTransfer is blocked, keep the visual state and use native picker flow.
      }

      if ($featuredPreview.length) {
        var featuredUrl = '';
        try {
          featuredUrl = URL.createObjectURL(file);
        } catch (err) {
          featuredUrl = '';
        }
        if (featuredUrl) {
          $featuredPreview.html('<img src="' + featuredUrl + '" alt="" style="width:120px;height:120px;object-fit:cover;border-radius:6px;" />');
        } else {
          $featuredPreview.empty();
        }
      }
    }

    $form.on('change', '.js-fundraiser-gallery-upload input[type="file"]', function() {
      var files = this.files;
      if (!files || !files.length) {
        selectedFiles = [];
        renderList();
        return;
      }
      selectedFiles = [];
      addFiles(files);
    });

    $form.on('click', '[data-remove-upload]', function(e) {
      e.preventDefault();
      var idx = parseInt($(this).data('remove-upload'), 10);
      if (!isNaN(idx)) {
        selectedFiles.splice(idx, 1);
        syncInput();
        renderList();
      }
    });

    $form.on('change', '.js-fundraiser-featured-upload input[type="file"]', function() {
      var files = this.files;
      setFeaturedFile(files && files.length ? files[0] : null);
    });

    var $dropArea = $form.find('.js-fundraiser-gallery-upload');
    $dropArea.on('dragenter dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $dropArea.addClass('uk-dragover');
    });

    $dropArea.on('dragleave dragend drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $dropArea.removeClass('uk-dragover');
    });

    $dropArea.on('drop', function(e) {
      var files = e.originalEvent.dataTransfer.files;
      if (!files || !files.length) return;
      addFiles(files);
    });

    var $featuredDropArea = $form.find('.js-fundraiser-featured-upload');
    $featuredDropArea.on('dragenter dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $featuredDropArea.addClass('uk-dragover');
    });

    $featuredDropArea.on('dragleave dragend drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $featuredDropArea.removeClass('uk-dragover');
    });

    $featuredDropArea.on('drop', function(e) {
      var files = e.originalEvent.dataTransfer.files;
      if (!files || !files.length) return;
      setFeaturedFile(files[0]);
    });

    restoreLoginGateDraft();
    syncEventTypeFields();
    syncReviewSubmitState();
    if ($form.length && $form.find('.mwm-step').eq(index).find('[data-review]').length) {
      renderReview();
    }
    showStep(index);
  }

  function initSponsorshipForm() {
    $(document).on('click', 'a[href="#sponsor-submission"], a[href$="/#sponsor-submission"]', function(e) {
      console.log('clack');
      var $modal = $('#sponsorship_submission');
      if ($modal.length < 1) return;
      e.preventDefault();
      if (typeof UIkit !== 'undefined' && typeof UIkit.modal === 'function') {
        UIkit.modal($modal).show();
        console.log('showed');
      }
    });

    var $forms = $('[data-sponsorship-form]');
    if ($forms.length < 1) return;

    $forms.each(function() {
      var $form = $(this);
      var $steps = $form.find('[data-sponsorship-step]');
      var $eventSelect = $form.find('[data-sponsorship-event-select]');
      var $otherWrap = $form.find('[data-sponsorship-other-wrap]');
      var $otherInput = $form.find('#sponsorship_event_other');
      var $totalRaised = $form.find('#sponsorship_total_raised');
      var $giftAidTotal = $form.find('#sponsorship_gift_aid_total');
      var $hiddenNyp = $form.find('input[name="nyp"]');
      var $hiddenEventLabel = $form.find('input[name="sponsorship_event_label"]');
      var $hiddenEventValue = $form.find('input[name="sponsorship_event_value"]');
      var $hiddenGiftAidTotal = $form.find('input[name="sponsorship_gift_aid_total_hidden"]');
      var stepIndex = 0;

      function showStep(index) {
        $steps.attr('hidden', true);
        $steps.eq(index).removeAttr('hidden');
      }

      function selectedEventLabel() {
        if (($eventSelect.val() || '') !== 'Other') {
          return $eventSelect.find('option:selected').text() || '';
        }
        var otherLabel = ($otherInput.val() || '').trim();
        return otherLabel || 'Other';
      }

      function syncOtherFieldVisibility() {
        var isOther = ($eventSelect.val() || '') === 'Other';
        $otherWrap.prop('hidden', !isOther);
      }

      function syncReview() {
        var total = parseFloat($totalRaised.val() || 0);
        var gift = parseFloat($giftAidTotal.val() || 0);
        var fileInput = $form.find('.js-sponsorship-proof-upload input[type="file"]')[0];
        var fileName = (fileInput && fileInput.files && fileInput.files.length) ? fileInput.files[0].name : 'None selected';

        $form.find('[data-sponsorship-review="event"]').text(selectedEventLabel() || '—');
        $form.find('[data-sponsorship-review="total"]').text(isNaN(total) ? '—' : ('£' + total.toFixed(2)));
        $form.find('[data-sponsorship-review="gift"]').text(isNaN(gift) ? '£0.00' : ('£' + gift.toFixed(2)));
        $form.find('[data-sponsorship-review="proof"]').text(fileName);
      }

      $form.on('click', '[data-sponsorship-next]', function(e) {
        e.preventDefault();
        syncOtherFieldVisibility();
        if (!$eventSelect[0].checkValidity()) {
          $eventSelect[0].reportValidity();
          return;
        }
        if (!$totalRaised[0].checkValidity()) {
          $totalRaised[0].reportValidity();
          return;
        }
        if (!$otherWrap.prop('hidden') && !$otherInput[0].checkValidity()) {
          $otherInput[0].reportValidity();
          return;
        }

        syncReview();
        stepIndex = 1;
        showStep(stepIndex);
      });

      $form.on('click', '[data-sponsorship-prev]', function(e) {
        e.preventDefault();
        stepIndex = 0;
        showStep(stepIndex);
      });

      $form.on('click', '[data-sponsorship-jump]', function(e) {
        e.preventDefault();
        stepIndex = Math.max(0, parseInt($(this).data('sponsorship-jump'), 10) - 1);
        showStep(stepIndex);
      });

      $eventSelect.on('change', syncOtherFieldVisibility);

      $form.on('submit', function(e) {
        var amount = parseFloat($totalRaised.val() || 0);
        if (isNaN(amount) || amount <= 0) {
          e.preventDefault();
          $totalRaised[0].reportValidity();
          return;
        }

        var giftAidAmount = parseFloat($giftAidTotal.val() || 0);
        if (isNaN(giftAidAmount) || giftAidAmount < 0) {
          giftAidAmount = 0;
        }

        $hiddenNyp.val(amount.toFixed(2));
        $hiddenEventLabel.val(selectedEventLabel());
        $hiddenEventValue.val(($eventSelect.val() || '').toString());
        $hiddenGiftAidTotal.val(giftAidAmount.toFixed(2));
      });

      var $proofUpload = $form.find('.js-sponsorship-proof-upload');
      var $proofInput = $proofUpload.find('input[type="file"]');
      var $proofLabel = $($proofUpload.data('upload-label'));
      var $proofPreview = $($proofUpload.data('preview'));

      $proofInput.on('change', function() {
        if (!this.files || !this.files.length) {
          $proofLabel.text('No file selected');
          $proofPreview.empty();
          return;
        }
        var file = this.files[0];
        $proofLabel.text(file.name);
        try {
          var previewUrl = URL.createObjectURL(file);
          $proofPreview.html('<img src="' + previewUrl + '" alt="" style="width:120px;height:120px;object-fit:cover;border-radius:6px;" />');
        } catch (err) {
          $proofPreview.empty();
        }
      });

      $proofUpload.on('dragenter dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $proofUpload.addClass('uk-dragover');
      });

      $proofUpload.on('dragleave dragend drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $proofUpload.removeClass('uk-dragover');
      });

      $proofUpload.on('drop', function(e) {
        var files = e.originalEvent.dataTransfer.files;
        if (!files || !files.length) return;
        try {
          $proofInput[0].files = files;
          $proofInput.trigger('change');
        } catch (err) {
          // Browser blocked assignment; user can use picker.
        }
      });

      if ($eventSelect.length && typeof $eventSelect.select2 === 'function') {
        $eventSelect.select2({
          width: '100%',
          dropdownAutoWidth: true
        });
      }

      syncOtherFieldVisibility();
      showStep(stepIndex);
    });
  }

  function initFundraiserDonateModal() {
    var $modal = $('#donatenow');
    if ($modal.length < 1) return;

    var $form = $modal.find('[data-fundraiser-donate-flow]');
    if ($form.length < 1) return;

    var $steps = $form.find('[data-donate-step]');
    var $linkedSteps = $modal.find('[data-donate-step]');
    var index = 0;
    var $anonymousToggle = $form.find('input[name="include_message"]');
    var $amountInput = $form.find('input[name="nyp"]');
    var $amountInputDisplay = $form.find('#fundraiser-donate-amount');
    var $optionalFields = $form.find('[data-optional-message-fields]');
    var $optionalNote = $form.find('[data-optional-message-note]');
    var $giftAidBonus = $form.find('[data-gift-aid-bonus]');
    var $giftAidDonation = $form.find('[data-gift-aid-donation]');
    var $stepThreeNextButton = $steps.filter('[data-donate-step="3"]').find('[data-donate-next]').first();
    var hasSavedGiftAidDeclaration = ($form.data('gift-aid-declared') || '').toString() === '1';

    if (hasSavedGiftAidDeclaration) {
      $form.find('input[name="gift_aid_check"]').val('1');
    }

    function isAnonymousDonation() {
      return $anonymousToggle.is(':checked');
    }

    function activeStepIndexes() {
      if (hasSavedGiftAidDeclaration) {
        return [0, 3];
      }
      return [0, 1, 2, 3];
    }

    function activeStepNumber() {
      return $steps.eq(index).data('donate-step');
    }

    function isGiftAidConfirmedForStep() {
      var $eventTaxpayer = $form.find('input[name="gift_aid_confirmed_event_taxpayer"]');
      var $eventIndividual = $form.find('input[name="gift_aid_confirmed_event_individual"]');
      if ($eventTaxpayer.length || $eventIndividual.length) {
        return $eventTaxpayer.is(':checked') && $eventIndividual.is(':checked');
      }

      var $standardConfirm = $form.find('input[name="gift_aid_confirmed"]');
      if ($standardConfirm.length) {
        return $standardConfirm.is(':checked');
      }

      return true;
    }

    function syncGiftAidStepButtonState() {
      if (!$stepThreeNextButton.length) return;
      if (activeStepNumber() !== 3) {
        $stepThreeNextButton.prop('disabled', false);
        return;
      }
      $stepThreeNextButton.prop('disabled', !isGiftAidConfirmedForStep());
    }

    function setDonationAmount(amount) {
      if (typeof amount === 'undefined' || amount === null || amount === '') return;
      var cleanAmount = String(amount).replace(/[^0-9.]/g, '');
      if (!cleanAmount) return;
      $amountInput.val(cleanAmount);
      if ($amountInputDisplay.length) {
        $amountInputDisplay.val(cleanAmount);
      }
      var $customInput = $form.find('.price-figure.custom input');
      if ($customInput.length) {
        $customInput.val(cleanAmount);
      }
      updateGiftAidPreview(cleanAmount);
    }

    function updateGiftAidPreview(amount) {
      if ((!$giftAidBonus.length && !$giftAidDonation.length)) return;
      var donation = parseFloat(String(amount || '').replace(/[^0-9.]/g, ''));
      if (isNaN(donation) || donation < 0) {
        donation = 0;
      }
      var bonus = donation * 0.25;
      if ($giftAidDonation.length) {
        $giftAidDonation.text(donation.toFixed(2));
      }
      if ($giftAidBonus.length) {
        $giftAidBonus.text(bonus.toFixed(2));
      }
    }

    function getCurrentDonationAmount() {
      var direct = ($amountInput.val() || '').toString().replace(/[^0-9.]/g, '');
      if (direct) return direct;

      var displayVal = ($amountInputDisplay.val() || '').toString().replace(/[^0-9.]/g, '');
      if (displayVal) return displayVal;

      var customVal = ($form.find('.price-figure.custom input, input.customprice').first().val() || '').toString().replace(/[^0-9.]/g, '');
      if (customVal) return customVal;

      return '';
    }

    function syncDonationAmountFromInputs() {
      var amount = getCurrentDonationAmount();
      if (amount) {
        $amountInput.val(amount);
      }
      updateGiftAidPreview(amount);
      return amount;
    }

    function resolveAmountFromTrigger($trigger) {
      var href = $trigger.attr('href') || '';
      if (href.indexOf('#donatenow') !== 0) return null;
      var parts = href.split('?');
      var params = new URLSearchParams(parts.length > 1 ? parts[1] : '');
      var amount = params.get('amount');

      if (amount === 'custom' || !amount) {
        var $scope = $trigger.closest('.price');
        if (!$scope.length) {
          $scope = $trigger.closest('.donation-side, .price-options, .fundraiser-preview, .mwm-fundraiser-preview');
        }
        var customVal = $scope.find('input.customprice, .price-figure.custom input').first().val();
        if (typeof customVal !== 'undefined' && customVal !== null && customVal !== '') {
          return customVal;
        }
        return null;
      }
      return amount;
    }

    function openDonateModal(options) {
      options = options || {};
      if (typeof options.amount !== 'undefined' && options.amount !== null) {
        setDonationAmount(options.amount);
      }
      UIkit.modal('#donatenow').show();
      if (options.skipAmountStep === true) {
        index = hasSavedGiftAidDeclaration ? 3 : 1;
      } else {
        index = 0;
      }
      showStep(index);
    }

    function showStep(i) {
      var stepNumber = $steps.eq(i).data('donate-step');
      $linkedSteps.attr('hidden', true);
      $linkedSteps.filter('[data-donate-step="' + stepNumber + '"]').removeAttr('hidden');
      if (stepNumber === 2) {
        syncDonationAmountFromInputs();
      }
      if (stepNumber === 4) {
        syncAnonymousDonationState();
      }
      syncGiftAidStepButtonState();
    }

    function syncAnonymousDonationState() {
      var $messageField = $form.find('[data-anonymous-message-field]');
      var isAnonymous = isAnonymousDonation();

      if ($messageField.length) {
        $messageField.prop('hidden', isAnonymous);
      }

      if ($optionalFields.length) {
        $optionalFields.find('textarea[name="fundraiser_message"]').prop('disabled', isAnonymous);
        if (isAnonymous) {
          $optionalFields.find('textarea[name="fundraiser_message"]').val('');
        }
      }

      if ($optionalNote.length) {
        $optionalNote.prop('hidden', !isAnonymous);
      }
    }

    function proceedDonateStep() {
      var sequence = activeStepIndexes();
      var currentPos = sequence.indexOf(index);
      if (currentPos > -1 && currentPos < sequence.length - 1) {
        index = sequence[currentPos + 1];
        showStep(index);
      }
    }

    function saveGiftAidDetailsThenProceed() {
      var $giftAidForm = $form.find('[data-gift-aid-form]');
      if (!$giftAidForm.length) {
        proceedDonateStep();
        return;
      }

      var $requiredFields = $giftAidForm.find('input[required]');
      for (var i = 0; i < $requiredFields.length; i++) {
        if (!$requiredFields[i].checkValidity()) {
          $requiredFields[i].reportValidity();
          return;
        }
      }

      var payload = {
        action: 'mwm_save_gift_aid_details',
        mwm_gift_aid_nonce: $giftAidForm.find('input[name="mwm_gift_aid_nonce"]').val() || '',
        gift_aid_title: $giftAidForm.find('input[name="gift_aid_title"]').val() || '',
        gift_aid_first_name: $giftAidForm.find('input[name="gift_aid_first_name"]').val() || '',
        gift_aid_last_name: $giftAidForm.find('input[name="gift_aid_last_name"]').val() || '',
        gift_aid_address: $giftAidForm.find('input[name="gift_aid_address"]').val() || '',
        gift_aid_postcode: $giftAidForm.find('input[name="gift_aid_postcode"]').val() || '',
        gift_aid_confirmed: $giftAidForm.find('input[name="gift_aid_confirmed"]').is(':checked') ? '1' : ''
      };
      var $eventTaxpayer = $giftAidForm.find('input[name="gift_aid_confirmed_event_taxpayer"]');
      if ($eventTaxpayer.length) {
        payload.gift_aid_confirmed_event_taxpayer = $eventTaxpayer.is(':checked') ? '1' : '';
      }
      var $eventIndividual = $giftAidForm.find('input[name="gift_aid_confirmed_event_individual"]');
      if ($eventIndividual.length) {
        payload.gift_aid_confirmed_event_individual = $eventIndividual.is(':checked') ? '1' : '';
      }

      var ajaxUrl = $giftAidForm.data('gift-aid-ajax-url') || (window.mwmAjax ? window.mwmAjax.ajaxurl : '');
      if (!ajaxUrl) {
        proceedDonateStep();
        return;
      }

      $.post(ajaxUrl, payload).always(function() {
        proceedDonateStep();
      });
    }

    $('body').on('click', 'a[href^="#donatenow"]', function(e) {
      e.preventDefault();
      var $trigger = $(this);
      var amount = resolveAmountFromTrigger($trigger);
      var shouldSkipAmountStep = amount !== null && amount !== '';
      openDonateModal({
        amount: amount,
        skipAmountStep: shouldSkipAmountStep
      });
    });

    $form.on('input change', '.price-figure.custom input, input.customprice, #fundraiser-donate-amount', function() {
      syncDonationAmountFromInputs();
    });

    $form.on('click', '[data-donate-next]', function(e) {
      e.preventDefault();
      if (activeStepNumber() === 2) {
        $form.find('input[name="gift_aid_check"]').val('1');
      }
      if (activeStepNumber() === 1) {
        var amount = syncDonationAmountFromInputs();
        if (!amount || parseFloat(amount) <= 0) {
          return;
        }
      }

      if (activeStepNumber() === 3) {
        if (!isGiftAidConfirmedForStep()) {
          syncGiftAidStepButtonState();
          return;
        }
        saveGiftAidDetailsThenProceed();
        return;
      }

      proceedDonateStep();
    });

    $form.on('click', '[data-donate-prev]', function(e) {
      e.preventDefault();
      var sequence = activeStepIndexes();
      var currentPos = sequence.indexOf(index);
      if (currentPos > 0) {
        index = sequence[currentPos - 1];
        showStep(index);
      }
    });

    $form.on('click', '[data-donate-skipgift]', function(e) {
      e.preventDefault();

      // Explicitly disable Gift Aid when user chooses to skip it.
      $form.find('input[name="gift_aid_check"]').val('0');
      var $giftAidToggle = $form.find('input[name="gift_aid_check"]');
      if ($giftAidToggle.length) {
        $giftAidToggle.prop('checked', false);
      }

      // Jump straight to the optional message step.
      index = 3;
      showStep(index);
    });

    $anonymousToggle.on('change', function() {
      if (activeStepNumber() === 4) {
        syncAnonymousDonationState();
      }
    });

    $form.on('change', 'input[name="gift_aid_confirmed"], input[name="gift_aid_confirmed_event_taxpayer"], input[name="gift_aid_confirmed_event_individual"]', function() {
      syncGiftAidStepButtonState();
    });

    $form.on('submit', function() {
      syncDonationAmountFromInputs();
      syncAnonymousDonationState();
    });

    syncGiftAidStepButtonState();
    showStep(index);
  }

  function initFundraiserDonationPagination() {
    var $feeds = $('[data-fundraiser-donations]');
    if ($feeds.length < 1) return;
    if (typeof mwmAjax === 'undefined' || !mwmAjax.ajaxurl) return;

    $feeds.each(function() {
      var $feed = $(this);
      var isLoading = false;

      function updatePaginationState(currentPage, totalPages) {
        $feed.attr('data-current-page', currentPage);
        $feed.attr('data-total-pages', totalPages);

        var $prev = $feed.find('[data-donation-page-prev]');
        var $next = $feed.find('[data-donation-page-next]');
        var $label = $feed.find('[data-donation-page-label]');

        var canGoPrevious = currentPage > 1 && !isLoading;
        var canGoNext = currentPage < totalPages && !isLoading;

        $prev.prop('disabled', !canGoPrevious);
        $next.prop('disabled', !canGoNext);

        $prev.toggleClass('mwm-hidden', !canGoPrevious);
        $next.toggleClass('mwm-hidden', !canGoNext);

        $label.text('Page ' + currentPage + ' of ' + totalPages);
      }

      // Initialize button visibility on first load
      updatePaginationState(
        parseInt($feed.attr('data-current-page'), 10) || 1,
        parseInt($feed.attr('data-total-pages'), 10) || 1
      );

      function loadPage(targetPage) {
        if (isLoading) return;

        var fundraiserId = parseInt($feed.attr('data-fundraiser-id'), 10);
        var perPage = parseInt($feed.attr('data-per-page'), 10) || 24;
        var totalPages = parseInt($feed.attr('data-total-pages'), 10) || 1;
	        var nonce = $feed.attr('data-nonce') || '';
	        var page = Math.max(1, Math.min(targetPage, totalPages));
	        isLoading = true;
        $feed.attr('aria-busy', 'true');
        $feed.addClass('is-loading');
        updatePaginationState(parseInt($feed.attr('data-current-page'), 10) || 1, totalPages);

        $.post(mwmAjax.ajaxurl, {
          action: 'mwm_fundraiser_donation_page',
          nonce: nonce,
          fundraiser_id: fundraiserId,
          page: page,
          per_page: perPage
	        }).done(function(response) {
	          if (!response || !response.success || !response.data) {
	            return;
	          }

          $feed.find('[data-donation-list]').html(response.data.html || '');
          updatePaginationState(parseInt(response.data.page, 10) || 1, parseInt(response.data.total_pages, 10) || 1);

          if (window.UIkit && typeof UIkit.update === 'function') {
            UIkit.update($feed.get(0));
          }
	        }).fail(function() {
	        }).always(function() {
          isLoading = false;
          $feed.removeClass('is-loading');
          $feed.attr('aria-busy', 'false');
          updatePaginationState(
            parseInt($feed.attr('data-current-page'), 10) || 1,
            parseInt($feed.attr('data-total-pages'), 10) || 1
          );
        });
      }

      $feed.on('click', '[data-donation-page-prev]', function(e) {
        e.preventDefault();
        var currentPage = parseInt($feed.attr('data-current-page'), 10) || 1;
        loadPage(currentPage - 1);
      });

      $feed.on('click', '[data-donation-page-next]', function(e) {
        e.preventDefault();
        var currentPage = parseInt($feed.attr('data-current-page'), 10) || 1;
        loadPage(currentPage + 1);
      });
    });
  }

  function initAuthFlow() {
    var $flows = $('[data-auth-flow]');
    if ($flows.length < 1) return;

    $flows.each(function() {
      var $flow = $(this);
      var $targets = $flow.find('[data-auth-panel-target]');
      var $panels = $flow.find('[data-auth-panel]');

      function showPanel(panelName) {
        $panels.attr('hidden', true).removeClass('is-active');
        $targets.removeClass('is-active').attr('aria-pressed', 'false');

        $flow.find('[data-auth-panel="' + panelName + '"]').removeAttr('hidden').addClass('is-active');
        $flow.find('[data-auth-panel-target="' + panelName + '"]').addClass('is-active').attr('aria-pressed', 'true');
      }

      $flow.on('click', '[data-auth-panel-target]', function(e) {
        e.preventDefault();
        showPanel($(this).data('auth-panel-target'));
      });

      showPanel('login');
    });
  }

  function initShareLinks() {
    function isLikelyMobile() {
      if (window.matchMedia && window.matchMedia('(max-width: 960px)').matches) {
        return true;
      }
      return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
    }

    $(document).on('click', 'a[href="#share"]', async function(e) {
      var $modal = $('#share');
      if ($modal.length < 1) return;

      var shareUrl = $modal.find('[data-share-modal]').attr('data-share-url') || window.location.href;
      var shareTitle = $modal.find('[data-share-modal]').attr('data-share-title') || document.title;
      var shareText = $modal.find('[data-share-modal]').attr('data-share-text') || '';

      if (isLikelyMobile() && navigator.share) {
        e.preventDefault();
        try {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: shareUrl
          });
          return;
        } catch (err) {
          // Fall back to modal when share is dismissed or unsupported.
        }
      }

      e.preventDefault();
      if (typeof UIkit !== 'undefined' && typeof UIkit.modal === 'function') {
        UIkit.modal('#share').show();
      }
    });

    $(document).on('click', '[data-share-copy]', function(e) {
      e.preventDefault();
      var $modal = $('#share');
      if ($modal.length < 1) return;
      var shareUrl = $modal.find('[data-share-modal]').attr('data-share-url') || window.location.href;
      var $button = $(this);

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareUrl).then(function() {
          $button.html('<span uk-icon="icon: check; ratio: 1" class="uk-icon"><svg width="20" height="20" viewBox="0 0 20 20"><polyline fill="none" stroke="#000" stroke-width="1.1" points="4,10 8,15 17,4"></polyline></svg></span>');
        });
      }
    });
  }

  function initCheckoutGiftAidToggle() {
    function getCheckoutFieldValue(fieldName) {
      var $field = $('#'+fieldName);
      if (!$field.length) {
        $field = $('[name="'+fieldName+'"]').first();
      }
      if (!$field.length) return '';
      return ($field.val() || '').toString().trim();
    }

    function prefillGiftAidFromCheckout($scope) {
      if (!$scope || !$scope.length) return;

      var fieldMap = {
        billing_title: 'gift_aid_title',
        billing_first_name: 'gift_aid_first_name',
        billing_last_name: 'gift_aid_last_name',
        billing_address_1: 'gift_aid_address',
        billing_postcode: 'gift_aid_postcode'
      };

      $.each(fieldMap, function(checkoutField, giftAidField) {
        var checkoutValue = getCheckoutFieldValue(checkoutField);
        if (!checkoutValue) return;

        var $giftAidField = $scope.find('[name="'+giftAidField+'"]').first();
        if (!$giftAidField.length) return;

        var existingGiftAidValue = ($giftAidField.val() || '').toString().trim();
        if (existingGiftAidValue) return;

        $giftAidField.val(checkoutValue).trigger('change');
      });
    }

    function syncCheckoutGiftAidComponent($container, animate) {
      var $checkbox = $container.find('.gift-aid-option input[name="gift_aid_check"]').first();
      var $component = $container.find('.gift-aid-component').first();

      if (!$checkbox.length || !$component.length) return;

      var shouldHide = $checkbox.is(':checked');

      if (shouldHide) {
        if (animate) {
          $component.stop(true, true).slideUp(180, function() {
            $component.attr('hidden', true);
          });
        } else {
          $component.stop(true, true).hide().attr('hidden', true);
        }
      } else {
        $component.removeAttr('hidden');
        if (animate) {
          $component.stop(true, true).slideDown(180);
        } else {
          $component.stop(true, true).show();
        }
      }
    }

    $('.mwm-checkout-gift-aid').each(function() {
      syncCheckoutGiftAidComponent($(this), false);
    });

    $(document).on('change', '.mwm-checkout-gift-aid .gift-aid-option input[name="gift_aid_check"]', function() {
      syncCheckoutGiftAidComponent($(this).closest('.mwm-checkout-gift-aid'), true);
    });

    $(document).on('click', '.mwm-checkout-gift-aid [data-donate-giftaid="1"]', function(e) {
      e.preventDefault();
      var $form = $(this).parents('.gift-aid-component').find('.gift-aid-form.closed');
      if ($form.length) {
        prefillGiftAidFromCheckout($form);
        $form.removeClass('closed').stop(true, true).slideDown(220);
        $(this).fadeOut().slideUp();
      }
    });
    
  }



function initFundraiserStoryReadMore() {
    var $wraps = $('.fundraiser-story-wrap');
    if (!$wraps.length) return;

    var collapsedHeightRem = '10rem';
    var rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize || '16') || 16;
    var collapsedHeightPx = (rootFontSize * 10) + 1;

    $wraps.each(function() {
        var $wrap = $(this);
        var $story = $wrap.find('.fundraiser-story').first();
        var $button = $wrap.find('.read-more').first();
        if (!$story.length || !$button.length) return;

        var isOverflowing = $story[0].scrollHeight > collapsedHeightPx;
        if (!isOverflowing) {
            $button.hide();
            $story.removeClass('is-collapsed is-open').css('height', '');
            return;
        }

        $button.show().text('Read more');
        $story.addClass('is-collapsed').removeClass('is-open').css('height', collapsedHeightRem);
    });

    $wraps.off('click.mwmStoryReadMore', '.read-more').on('click.mwmStoryReadMore', '.read-more', function(e) {
        e.preventDefault();
        var $button = $(this);
        var $story = $button.closest('.fundraiser-story-wrap').find('.fundraiser-story').first();
        if (!$story.length) return;

        if ($story.hasClass('is-open')) {
            $story.stop().animate({ height: collapsedHeightRem }, 300).removeClass('is-open');
            $button.text('Read more');
            return;
        }

        $story.stop().animate({ height: $story[0].scrollHeight }, 300).addClass('is-open');
        $button.text('Read less');
    });
}

initFundraiserStoryReadMore(); 


  gizmemoarposts();

function gizmemoarposts() {

    var gizmoar = $('#gizmoreposts');

    if(gizmoar.length < 1) {
      return false;
    }
    
    if(gizmoar.data('arch-mode') == 'click') {

        $('#gizmoreposts > a').on('click', function(e) {
            e.preventDefault();
            loadmoar_posts($(this));
        });

    }
    
    if(gizmoar.data('arch-mode') == 'auto') {

        UIkit.util.on('#gizmoreposts', 'inview', function() {
            loadmoar_posts($(this));
        });
    
    }

} // End moar posts


function loadmoar_posts(thisthing) {
  var nextpostslink = thisthing.find('a');

  console.log('this far');

  //console.log(nextpostslink);
  if(nextpostslink.length < 1 || nextpostslink.hasClass('loading')) return;
  
  // load more

      var link = nextpostslink.attr('href'),
          container = nextpostslink.parents('.feed-outer');

      nextpostslink.addClass('loading');
      nextpostslink.hide();
      thisthing.find('div.gizspinner').fadeIn();
      
      // console.log(link);
      // console.log(container);
      
      $.get(link, function(data) {
        
        var posts = $('#content .post-feed .feed-inner > article.post', data),
        newmoar = $('#content .post-feed #gizmoreposts a', data);
        
        $('#content .feed-outer .feed-inner').append(posts);
        $('#content .feed-outer #gizmoreposts').html(newmoar);
        
        thisthing.find('div.gizspinner').fadeOut('400', function() {
          nextpostslink.removeClass('loading').show();
        });
        
      });
  }



  $('#mobile-menu').on('tap, click', 'li.menu-item-has-children > a', function(e){
    if($(this).parent('.menu-item-has-children').hasClass('.depth-1')) return;

    //e.preventDefault();

    $(this).parents('li.menu-item-has-children').addClass('active');
    $(this).parents('.menu-inner').addClass('sub-active');
    var subheight = $(this).parents('li.menu-item-has-children').find('.sub-menu').outerHeight();
    //console.log(subheight);
    $(this).parents('.menu-container').css('min-height', subheight);
}).on('tap, click', 'li.wehavetogoback', function(e) {
    $('li.menu-item-has-children').removeClass('active');
    $(this).parents('.menu-inner').removeClass('sub-active');
    //console.log('boop');
});





UIkit.util.on('body', 'show', function () {
  $('.burger').addClass('open opened');
});

UIkit.util.on('body', 'hide', function () {
  $('.burger').removeClass('open');
});

let currentlyPlayingVideo = null; // Variable to store the currently playing video

// When the modal opens
UIkit.util.on('.videomodal', 'show', function () {
    const videos = document.querySelectorAll('video');

    videos.forEach(video => {
        if (!video.paused) {
            // If the video is playing, store a reference to it and pause it
            currentlyPlayingVideo = video;
            video.pause();
        }
    });
});

// When the modal closes
UIkit.util.on('.videomodal', 'hide', function () {
    if (currentlyPlayingVideo) {
        currentlyPlayingVideo.play();
        currentlyPlayingVideo = null; // Reset after resuming
    }
});


UIkit.util.on('.feature.stat', 'inview', function () {
  var num = $(this).find('.stat_num');
  console.log(num);
  countUpNumber(num);
});



function generateBlob() {
  const random = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  const percentage1 = random(40, 60);
  const percentage2 = random(40, 60);
  const percentage3 = random(40, 60);
  const percentage4 = random(40, 60);
  var percentage11 = 100 - percentage1;
  var percentage21 = 100 - percentage2;
  var percentage31 = 100 - percentage3;
  var percentage41 = 100 - percentage4;
  var borderRadius = `${percentage1}% ${percentage11}% ${percentage21}% ${percentage2}% / ${percentage3}% ${percentage4}% ${percentage41}% ${percentage31}%`;
  return borderRadius
}

// Function to generate a new border-radius value and apply it
function updateBlobs() {
  var stepblobs = $('.step-blob-background');
  
  stepblobs.each(function(i) {
    // Generate the border-radius value using your generateBlob function
    var newBorderRadius = generateBlob(),
        parentstep = $(this).parents('.step');
    $(this).css('border-radius', newBorderRadius);
    // Add a delay for each blob to fade in with a 500ms delay per blob
    if (!parentstep.hasClass('onit')) {
      setTimeout(() => {
        parentstep.addClass('onit'); // Trigger opacity change via CSS class
      }, i * 750); // 500ms delay between each blob
    }
  });
}

// // Call updateBlobs every 5 seconds
// setInterval(updateBlobs, 2500);
// Initial call to apply a starting border-radius
updateBlobs();


function dothesliders() {
    var $slider = $('.selector-slider');
    if($slider.length < 1) return false;

    let autoplayTimeout;

    // Function to start the autoplay timeout
    function startAutoplay() {
        clearTimeout(autoplayTimeout); // Clear any existing timeout
        autoplayTimeout = setTimeout(function() {
            UIkit.slider($slider).show('next');
        }, 12000);
    }

    // Function to handle indicator animation
    function animateIndicators() {
        var $activeSlide = $slider.find('.uk-active');
        var choices = $slider.find('.story-choice');

        choices.each(function() { 
            if ($(this).is($activeSlide)) {
                $(this).find('.indicator').css({
                    'transition': 'transform 12s linear, bottom 0.3s linear',
                    'transform': 'scaleX(0)',
                });
            } else {
                $(this).find('.indicator').css({
                    'transition': 'transform 0s, bottom 0.3s linear',
                    'transform': 'scaleX(1)',
                });
            }
        });
    }

    // Event listener for when a new item is shown
    $slider.on('itemshow', function () {
        animateIndicators(); // Animate indicators on each item change
        startAutoplay();     // Restart the autoplay timer
    });

    // Initial call to start autoplay and animate indicators on page load
    animateIndicators();
    startAutoplay();
}

// Call the function to initialize
dothesliders();

function checkAvailability() {
  const $available = $('span.available');
  if ($available.length === 0) return;

  // Get current time in London (handles GMT/BST automatically)
  const now = new Date();
  const dayName = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    weekday: 'long'
  }).format(now);
  const dayMap = {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  };
  const day = dayMap[dayName] !== undefined ? dayMap[dayName] : now.getDay();

  const hourString = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    hour: '2-digit',
    hour12: false
  }).format(now);
  const hours = parseInt(hourString, 10);

  // Between Monday (1) and Friday (5) and 10:00–16:00 London time
  if (day >= 1 && day <= 5 && hours >= 10 && hours < 16) {
    $available.addClass('open');
  } else {
    $available.removeClass('open');
  }
}

// Run the function on page load
checkAvailability();

// Check every 60 seconds to keep the status up-to-date
setInterval(checkAvailability, 60000); // Check every 60 seconds


  // Check if .mwmcb_donation exists
  if ($('.mwmcb_donation').length) {
    // Select the number input and the donate button
    var $input = $('.price-figure.custom input');
    var $button = $('.mwm-button');

    $input.on('input', function() {
        // Get the entered amount and remove any currency symbols
        var amount = $(this).val().replace(/[^0-9.]/g, ''),
            container = $(this).parents('.price'),
            $button = container.find('.mwm-button');

        if (amount) {
            // Update the button label with the custom amount
            $button.text('Donate £' + amount);

            // Update the URL with the custom amount in the 'nyp' query parameter
            var currentHref = $button.attr('href');
            var newHref = currentHref.replace(/(nyp=)[^&]*/, '$1' + amount);
            $button.attr('href', newHref);

            console.log(amount);
            console.log(currentHref.replace(/(nyp=)[^&]*/, '$1' + amount));
        } else {
            // Reset button text if input is empty
            $button.text('Donate custom');
        }
    });
  }

  // $('.woocommerce-cart-form__contents .input-text.qty').on('change', function() {
  //   // Trigger the update cart button click
  //   $('button[name="update_cart"]').trigger('click');
  //   console.log('did it');
  // });


  $('[data-args]').each(function() {
      const feedRoot = $(this);
      const container = feedRoot.find('.feed-inner');
      const loadMoreButton = feedRoot.find('#ajaxloadmore');
      const taxonomyFilter = feedRoot.find('#taxonomy-filter');
      const sortFilter = feedRoot.find('#sort-filter');
      const baseArgs = feedRoot.attr('data-args') || '';
      let pageSize = 9;

      if (baseArgs) {
          try {
              const parsedBaseArgs = JSON.parse(window.atob(baseArgs));
              if (parsedBaseArgs.posts_per_page) {
                  pageSize = parseInt(parsedBaseArgs.posts_per_page, 10) || pageSize;
              }
          } catch (err) {
              console.warn('Invalid feed base args', err);
          }
      }

      if (container.length === 0) {
          return;
      }

      let paged = 2; // Track pages per feed instance

      function fetchFilteredPosts() {
          const taxonomy = taxonomyFilter.val();
          const sort = sortFilter.val();
          paged = 1; // Reset pagination when filters change

	          $.ajax({
	              url: mwmAjax.ajaxurl,
	              type: 'POST',
	              data: {
	                  action: 'cinnamon_filter_sort_posts',
	                  nonce: mwmAjax.feedNonce,
	                  base_args: baseArgs,
	                  taxonomy: taxonomy,
	                  sort: sort,
	                  paged: paged
	              },
              beforeSend: function() {
                  container.html('<div class="uk-text-center"><div uk-spinner></div></div>');
              },
              success: function(response) {
                  if (response.html) {
                      container.html(response.html);
                      paged = 2; // Reset to next page for Load More

                      if (response.post_count < pageSize) {
                          loadMoreButton.hide();
                      } else {
                          loadMoreButton.show().data('paged', paged);
                      }
                  } else {
                      container.html('<p>No posts found.</p>');
                      loadMoreButton.hide();
                  }
              },
              error: function() {
                  container.html('<p>Error loading posts.</p>');
              }
          });
      }

      function initializeLoadMore() {
          if (loadMoreButton.length === 0) {
              return;
          }

          loadMoreButton.on('click', function(e) {
              e.preventDefault();
              if (loadMoreButton.hasClass('loading')) return;

              const taxonomy = taxonomyFilter.val();
              const sort = sortFilter.val();

	              $.ajax({
	                  url: mwmAjax.ajaxurl,
	                  type: 'POST',
	                  data: {
	                      action: 'cinnamon_filter_sort_posts',
	                      nonce: mwmAjax.feedNonce,
	                      base_args: baseArgs,
	                      taxonomy: taxonomy,
	                      sort: sort,
	                      paged: paged
	                  },
                  beforeSend: function() {
                      loadMoreButton.text('Loading...').addClass('loading');
                  },
                  success: function(response) {
                      if (response.html) {
                          container.append(response.html);
                          paged++; // Properly increment paged
                          loadMoreButton.data('paged', paged);

	                          if (response.post_count < pageSize) {
	                              loadMoreButton.hide();
	                          } else {
	                              loadMoreButton.text('Load More').removeClass('loading');
	                          }
                      } else {
                          loadMoreButton.hide();
                      }
                  },
                  error: function() {
                      loadMoreButton.text('Error, try again.').removeClass('loading');
                  }
              });
          });
      }

      // Initialize filters & load more per feed instance
      taxonomyFilter.add(sortFilter).on('change', function() {
          fetchFilteredPosts();
      });

      initializeLoadMore();
  });


  function rerenderAuthModalTurnstile(modalEl, attempt) {
    if (!modalEl) return;

    var tries = typeof attempt === 'number' ? attempt : 0;
    if (typeof window.turnstile === 'undefined' || typeof window.turnstile.render !== 'function') {
      if (tries < 12) {
        window.setTimeout(function() {
          rerenderAuthModalTurnstile(modalEl, tries + 1);
        }, 150);
      }
      return;
    }

    var widgets = modalEl.querySelectorAll('.cf-turnstile');
    if (!widgets.length) return;

    widgets.forEach(function(widget) {
      if (!widget) return;

      var hasMarkup = widget.innerHTML && widget.innerHTML.trim() !== '';
      if (hasMarkup && typeof window.turnstile.reset === 'function') {
        try {
          window.turnstile.reset(widget);
          return;
        } catch (err) {
          // Fall back to a fresh render when reset is unavailable for this node.
        }
      }

      if (hasMarkup && typeof window.turnstile.remove === 'function') {
        try {
          window.turnstile.remove(widget);
        } catch (err) {
          // If remove fails, render below will still attempt recovery.
        }
      }

      try {
        window.turnstile.render(widget);
      } catch (err) {
        if (widget.id) {
          try {
            window.turnstile.render('#' + widget.id);
          } catch (renderErr) {
            // Ignore repeated render failures.
          }
        }
      }
    });
  }

  function maybeRerenderAuthModalTurnstile(modalEl) {
    if (!modalEl || !modalEl.classList || !modalEl.classList.contains('mwm-auth-modal')) {
      return;
    }
    rerenderAuthModalTurnstile(modalEl, 0);
  }

  UIkit.util.on('.uk-modal', 'show', function (event) {
    var modal = event.target;
    maybeRerenderAuthModalTurnstile(modal);

    if (modal && modal.getAttribute('id') && modal.getAttribute('id').startsWith('tallymodal_')) {

        // Find the iframe inside the modal
        var iframe = modal.querySelector('iframe');
        if (iframe) {
            var src = new URL(iframe.getAttribute('data-tally-src'), window.location.origin);
            var page_title = $('#page_introduciton').find('.page-title').html();

            // Set the hidden field values dynamically
            src.searchParams.set('page_title', page_title);

            // Update the iframe src to reload with parameters
            iframe.setAttribute('data-tally-src', src.toString());
        }
    }

});

  UIkit.util.on('.mwm-auth-modal', 'shown', function(event) {
    maybeRerenderAuthModalTurnstile(event.target);
  });

  $(document).on('click', '.mwm-auth-modal [uk-tab] a', function(event) {
    var target = event.target && event.target.nodeType === 1 ? event.target : event.target.parentElement;
    var modalEl = target && target.closest ? target.closest('.mwm-auth-modal') : null;
    if (!modalEl) return;

    window.setTimeout(function() {
      maybeRerenderAuthModalTurnstile(modalEl);
    }, 150);
  });


});



(function ($) {

  function mwmReopenMiniCartIfNeeded() {
      if (!window.mwmMiniCartShouldStayOpen || !window.UIkit || !UIkit.offcanvas) return;

      window.setTimeout(function () {
          UIkit.offcanvas('#mini-cart-offcanvas').show();
          window.mwmMiniCartShouldStayOpen = false;
      }, 0);
  }

  function mwmReplaceCartFragments(fragments) {
      if (!fragments) return;

      const offcanvasWasOpen = $('#mini-cart-offcanvas').hasClass('uk-open');
      if (offcanvasWasOpen && fragments['#mini-cart-offcanvas']) {
          window.mwmMiniCartShouldStayOpen = true;
      }

      $.each(fragments, function (selector, html) {
          $(selector).replaceWith(html);
      });

      if (window.UIkit && UIkit.update) {
          UIkit.update();
      }

      mwmReopenMiniCartIfNeeded();
  }

  window.mwmReplaceCartFragments = mwmReplaceCartFragments;

  function mwmShowProductGallerySlide($form, variation) {
      if (!variation || !window.UIkit || !UIkit.slider) return;

      const imageId = variation.image_id ? String(variation.image_id) : '';
      const variationId = variation.variation_id ? String(variation.variation_id) : '';
      if (!imageId && !variationId) return;

      const $product = $form.closest('.product');
      const $slider = ($product.length ? $product : $(document)).find('.mwm-product-gallery-slider').first();
      if (!$slider.length) return;

      const slides = $slider.find('.uk-slider-items > *').toArray();
      const index = slides.findIndex(function (slide) {
          const $slide = $(slide);
          const slideImageId = String($slide.data('image-id') || '');
          const slideVariationIds = String($slide.data('variation-ids') || '').split(/\s+/);

          return (imageId && slideImageId === imageId) || (variationId && slideVariationIds.includes(variationId));
      });

      if (index < 0) return;

      const slider = UIkit.slider($slider[0]);
      if (slider && slider.stopAutoplay) {
          slider.stopAutoplay();
          slider.autoplay = false;
      }

      slider.show(index);
  }

  $(document).on('found_variation', 'form.variations_form', function (event, variation) {
      mwmShowProductGallerySlide($(this), variation);
  });

  $(document).on('reset_data', 'form.variations_form', function () {
      const $product = $(this).closest('.product');
      const $slider = ($product.length ? $product : $(document)).find('.mwm-product-gallery-slider').first();

      if ($slider.length && window.UIkit && UIkit.slider) {
          UIkit.slider($slider[0]).show(0);
      }
  });

  function mwmBuildAddToCartData($button) {
      const $form = $button.closest('form.cart');
      const isSingleProductButton = $button.hasClass('single_add_to_cart_button');

      if (isSingleProductButton && $form.length) {
          const id = $button.attr('data-id') || $button.val();
          const variationId = $form.find('input[name=variation_id]').val() || 0;
          const data = {
              // WooCommerce's AJAX add_to_cart handler expects the variation ID here
              // when a variable product is being added from a single product page.
              product_id: variationId || $form.find('input[name=product_id]').val() || id,
              product_sku: $button.data('product_sku') || '',
              quantity: $form.find('input[name=quantity]').val() || 1,
              variation_id: variationId
          };

          $form.serializeArray().forEach(function (field) {
              if (!field || !field.name) return;
              if (field.name === 'product_id' || field.name === 'variation_id' || field.name === 'add-to-cart') return;
              data[field.name] = field.value;
          });

          return data;
      }

      return {
          product_id: $button.data('product_id') || $button.attr('data-product_id') || $button.val(),
          product_sku: $button.data('product_sku') || '',
          quantity: $button.closest('.bump-functions, form, .product, li').find('input.qty[name="quantity"]').first().val() || $button.data('quantity') || 1,
          variation_id: 0
      };
  }

  function mwmSetAddToCartButtonText($button, text) {
      const $words = $button.find('span.wording');

      if ($words.length) {
          $words.html(text);
      } else {
          $button.html(text);
      }
  }

  function mwmSetAddToCartLoading($button) {
      $button.removeClass('added').addClass('loading');
      mwmSetAddToCartButtonText($button, 'Adding');
  }

  function mwmSetAddToCartComplete($button) {
      $button.addClass('added').removeClass('loading');
      mwmSetAddToCartButtonText($button, 'View Basket');
      $button.attr('uk-toggle', 'target: #mini-cart-offcanvas;');
      $button.find('span.add-to-check').attr('data-state', 'complete');
      $button.closest('.snl-product-inner').addClass('in-cart');
      $('body').addClass('ajaxaddedcart');
  }

  function mwmOpenMiniCartOffcanvas() {
      if (window.UIkit && UIkit.offcanvas) {
          UIkit.offcanvas('#mini-cart-offcanvas').show();
      }
  }

  function mwmAjaxAddToCart($button) {
      if ($button.hasClass('added')) return;

      const data = mwmBuildAddToCartData($button);

      $(document.body).trigger('adding_to_cart', [$button, data]);

      $.ajax({
          type: 'post',
          url: wc_add_to_cart_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
          data: $.param(data),
          dataType: 'json',
          beforeSend: function () {
              mwmSetAddToCartLoading($button);
          },
          complete: function () {
              mwmSetAddToCartComplete($button);
          },
          success: function (response) {
              if (!response) {
                  return;
              }

              if (response.error && response.product_url) {
                  window.location = response.product_url;
                  return;
              }

              $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);

              if (response.fragments) {
                  mwmReplaceCartFragments(response.fragments);
                  mwmOpenMiniCartOffcanvas();
              } else if (window.wc_cart_fragments_params) {
                  $(document.body).one('wc_fragments_refreshed.mwmAddToCart', function () {
                      mwmOpenMiniCartOffcanvas();
                  });
                  $(document.body).trigger('wc_fragment_refresh');
              }
          },
          error: function () {
            return;
          }
      });
  }

  $(document).on('click', '.single_add_to_cart_button, .ajax_add_to_cart:not(.add_to_cart_button)', function (e) {
      e.preventDefault();
      const $button = $(this);

      if ($button.hasClass('added')) return;

      mwmAjaxAddToCart($button);

      return false;
  });

    $(document).on('click', '#mini-cart-offcanvas .remove_from_cart_button', function () {
        window.mwmMiniCartShouldStayOpen = $('#mini-cart-offcanvas').hasClass('uk-open');
    });

    $(document.body).on('wc_fragment_refresh updated_wc_div', function () {
        if ($('#mini-cart-offcanvas').hasClass('uk-open')) {
            window.mwmMiniCartShouldStayOpen = true;
        }
    });

  	$(document.body).on('removed_from_cart wc_fragments_loaded wc_fragments_refreshed', function() {
        mwmReopenMiniCartIfNeeded();
      });

    $(document.body).on('updated_wc_div', function() {
        // Reinitialize anything UIkit-related inside the cart
        UIkit.update();
    });

// // FORCE BUTTONS MONKEY WRENCH

//       function transformButton($btn, primary = true) {
//           // Avoid duplicating if already styled
//           if ($btn.hasClass('mwm-button')) return;

//           $btn.addClass('mwm-button colour-light uk-button uk-button-large');
//           if (primary) {
//               $btn.addClass('uk-button-primary');
//               const text = $btn.text();
//               $btn.html('<span class="txt">' + text + '</span><span class="arrow uk-icon" uk-icon="icon: arrow-right; ratio: 1;"></span>');
//           } else {
//               $btn.addClass('uk-button-secondary');
//           }
//       }

//       // WooCommerce primary (typically checkout/submit actions)
//       $('.woocommerce button.button.alt, .woocommerce a.button.alt, .woocommerce input.button.alt').each(function () {
//           transformButton($(this), true);
//       });

//       // WooCommerce secondary (e.g. continue shopping, view cart)
//       $('.woocommerce button.button:not(.alt), .woocommerce a.button:not(.alt), .woocommerce input.button:not(.alt)').each(function () {
//           transformButton($(this), false);
//       });



  // Quantity plus/minus button event delegation
  $(document).on('click', '.qty-button', function (e) {
      e.preventDefault();
      const $input = jQuery(this).closest('.quantity').find('input.qty').first();
      let val = parseFloat($input.val()) || 0;
      const min = $input.attr('min') !== undefined && $input.attr('min') !== '' ? parseFloat($input.attr('min')) : 0;
      const max = $input.attr('max') !== undefined && $input.attr('max') !== '' ? parseFloat($input.attr('max')) : null;
      const step = $input.attr('step') !== undefined && $input.attr('step') !== '' ? parseFloat($input.attr('step')) : 1;

      if (jQuery(this).hasClass('qty-minus')) {
          val = Math.max(val - step, min);
      } else {
          val = val + step;
          if (max !== null) val = Math.min(val, max);
      }

      $input.val(val).trigger('change');
  });

  $(document).on('input change', '.mwm-mini-cart-qty', function () {
      const $input = $(this);
      const cartItemKey = $input.data('cart-item-key');

      if (!cartItemKey || typeof mwmAjax === 'undefined') return;

      clearTimeout($input.data('mwmMiniCartQtyTimer'));
      $input.data('mwmMiniCartQtyTimer', setTimeout(function () {
          $input.prop('disabled', true);

          $.post(mwmAjax.ajaxurl, {
              action: 'mwm_update_mini_cart_quantity',
              nonce: mwmAjax.miniCartQuantityNonce,
              cart_item_key: cartItemKey,
              quantity: $input.val()
          }).done(function (response) {
              if (response && response.fragments) {
                  mwmReplaceCartFragments(response.fragments);

                  $(document.body).trigger('wc_fragments_refreshed');
              }
          }).always(function () {
              $input.prop('disabled', false);
          });
      }, 350));
  });

})(jQuery);



// SNOW HERO
$(document).ready(function() {

    const hero = document.querySelector('.snow-hero');

    if (!hero) {
        return;
    }

    /*
     * Don't initialise at all for reduced-motion users.
     */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }


    /*
     * Snow configuration.
     *
     * Three separate canvas layers give us depth without
     * needing expensive per-particle blur effects.
     */
    const layerConfig = [
        {
            selector: '.snow-layer--back',
            count: 140,
            minSize: 0.5,
            maxSize: 1.5,
            minSpeed: 0.3,
            maxSpeed: 0.7,
            opacity: 0.4
        },
        {
            selector: '.snow-layer--mid',
            count: 180,
            minSize: 1,
            maxSize: 2.5,
            minSpeed: 0.55,
            maxSpeed: 1.1,
            opacity: 0.7
        },
        {
            selector: '.snow-layer--front',
            count: 70,
            minSize: 2,
            maxSize: 4,
            minSpeed: 0.8,
            maxSpeed: 1.5,
            opacity: 0.85
        }
    ];


    const random = (min, max) => {
        return Math.random() * (max - min) + min;
    };


    let width = 0;
    let height = 0;
    let dpr = 1;

    let animationFrame = null;
    let isVisible = false;
    let frameCount = 0;


    /*
     * Prepare each canvas layer.
     */
    const layers = layerConfig.map((config) => {

        const canvas = hero.querySelector(config.selector);

        if (!canvas) {
            return null;
        }

        return {
            ...config,
            canvas: canvas,
            ctx: canvas.getContext('2d'),
            flakes: []
        };

    }).filter(Boolean);


    if (!layers.length) {
        return;
    }


    /**
     * Create a single snowflake.
     */
    function createFlake(layer, randomY = false) {

        return {
            x: random(0, width),

            y: randomY
                ? random(0, height)
                : random(-40, -5),

            size: random(
                layer.minSize,
                layer.maxSize
            ),

            /*
             * Every flake gets its own slight horizontal
             * momentum so they don't all follow the same path.
             */
            vx: random(-0.15, 0.15),

            vy: random(
                layer.minSpeed,
                layer.maxSpeed
            )
        };

    }


    /**
     * Recycle a flake once it leaves the bottom.
     */
    function resetFlake(flake, layer) {

        flake.x = random(-20, width + 20);
        flake.y = random(-40, -5);

        flake.size = random(
            layer.minSize,
            layer.maxSize
        );

        flake.vx = random(-0.15, 0.15);

        flake.vy = random(
            layer.minSpeed,
            layer.maxSpeed
        );

    }


    /**
     * Resize canvases to match the hero.
     */
    function resize() {

        const rect = hero.getBoundingClientRect();

        width = rect.width;
        height = rect.height;


        /*
         * Cap DPR at 2.
         *
         * Tiny snow particles don't benefit enough from
         * rendering at 3x/4x to justify the extra pixels.
         */
        dpr = Math.min(
            window.devicePixelRatio || 1,
            2
        );


        layers.forEach((layer) => {

            layer.canvas.width = Math.round(
                width * dpr
            );

            layer.canvas.height = Math.round(
                height * dpr
            );

            layer.canvas.style.width = `${width}px`;
            layer.canvas.style.height = `${height}px`;


            /*
             * Draw using CSS pixel coordinates while the
             * canvas itself remains high-DPI.
             */
            layer.ctx.setTransform(
                dpr,
                0,
                0,
                dpr,
                0,
                0
            );


            /*
             * Rebuild particles after resize so everything
             * fits naturally inside the new dimensions.
             */
            layer.flakes = [];

            for (let i = 0; i < layer.count; i++) {

                layer.flakes.push(
                    createFlake(layer, true)
                );

            }

        });

    }


    /**
     * Render the snow.
     */
    function render() {

        frameCount++;


        /*
         * We only alter the airflow occasionally.
         *
         * This gives each flake little changes in direction
         * without doing random calculations every frame.
         */
        const changeAirflow =
            frameCount % 20 === 0;


        layers.forEach((layer) => {

            const ctx = layer.ctx;
            const flakes = layer.flakes;


            /*
             * Clear this layer.
             */
            ctx.clearRect(
                0,
                0,
                width,
                height
            );


            /*
             * Set fill style once for the entire layer.
             */
            ctx.fillStyle =
                `rgba(255, 255, 255, ${layer.opacity})`;


            /*
             * Build all snowflakes into one canvas path.
             *
             * This means we only call fill() once per layer,
             * rather than once for every snowflake.
             */
            ctx.beginPath();


            for (let i = 0; i < flakes.length; i++) {

                const flake = flakes[i];


                /*
                 * Occasionally give the flake a tiny gust.
                 *
                 * The velocity persists afterwards, which
                 * creates more natural wandering paths than
                 * changing direction every frame.
                 */
                if (changeAirflow) {

                    flake.vx += random(
                        -0.04,
                        0.04
                    );


                    /*
                     * Keep horizontal speed under control.
                     */
                    flake.vx = Math.max(
                        -0.45,
                        Math.min(
                            0.45,
                            flake.vx
                        )
                    );

                }


                /*
                 * Move the flake.
                 */
                flake.x += flake.vx;
                flake.y += flake.vy;


                /*
                 * Wrap horizontally.
                 *
                 * This feels more like a continuous field
                 * of snow than constantly respawning flakes.
                 */
                if (flake.x > width + 10) {
                    flake.x = -10;
                }

                if (flake.x < -10) {
                    flake.x = width + 10;
                }


                /*
                 * Once a flake falls below the hero,
                 * recycle it above the top.
                 */
                if (flake.y > height + 10) {

                    resetFlake(
                        flake,
                        layer
                    );

                }


                /*
                 * Add this flake to the shared path.
                 */
                ctx.moveTo(
                    flake.x + flake.size,
                    flake.y
                );

                ctx.arc(
                    flake.x,
                    flake.y,
                    flake.size,
                    0,
                    Math.PI * 2
                );

            }


            /*
             * One draw operation for the entire layer.
             */
            ctx.fill();

        });


        /*
         * Only continue while the hero is visible.
         */
        if (isVisible) {

            animationFrame =
                requestAnimationFrame(render);

        }

    }


    /**
     * Pause the animation when the hero leaves the viewport.
     *
     * Once the user scrolls past the hero we're no longer
     * burning animation frames on invisible snow.
     */
    const observer = new IntersectionObserver(
        function(entries) {

            entries.forEach((entry) => {

                if (entry.isIntersecting) {

                    if (!isVisible) {

                        isVisible = true;

                        animationFrame =
                            requestAnimationFrame(render);

                    }

                } else {

                    isVisible = false;

                    if (animationFrame) {

                        cancelAnimationFrame(
                            animationFrame
                        );

                        animationFrame = null;

                    }

                }

            });

        },
        {
            threshold: 0
        }
    );


    /**
     * Resize handling.
     *
     * Debouncing through requestAnimationFrame prevents
     * resize() firing repeatedly within the same frame.
     */
    let resizeFrame = null;

    window.addEventListener('resize', function() {

        if (resizeFrame) {
            cancelAnimationFrame(resizeFrame);
        }

        resizeFrame = requestAnimationFrame(function() {

            resize();

            resizeFrame = null;

        });

    });


    /*
     * Initialise.
     */
    resize();

    observer.observe(hero);

});








// document.addEventListener('DOMContentLoaded', () => {
//   const video = document.getElementById('player');
//   const source = document.getElementById('videoSource').getAttribute('src'); // Get the source dynamically

//   // Check if the browser supports HLS natively (e.g., Safari)
//   if (video.canPlayType('application/vnd.apple.mpegurl')) {
//       video.src = source; // Use the dynamic HLS source for native browsers
//       console.log('can play HLS native');
//     } else if (Hls.isSupported()) {
//       // For browsers that do not support HLS natively, use HLS.js
//       const hls = new Hls();
//       hls.loadSource(source); // Use the dynamic HLS source
//       hls.attachMedia(video);
//       console.log('Loaded non HLS');
//   }

//   // Initialize Plyr.js
//   const player = new Plyr(video);
//   console.log('got to the end');
// });

document.addEventListener('DOMContentLoaded', () => {
  const videos = document.querySelectorAll('.video-player');
  if (videos.length < 1) return;

  function hasNativeHlsSupport() {
    const v = document.createElement('video');
    const canPlay = v.canPlayType('application/vnd.apple.mpegurl');
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari && !!canPlay;
  }

  if (hasNativeHlsSupport()) {
    videos.forEach(video => {
      const sourceEl = video.querySelector('source');
      const source = sourceEl ? sourceEl.getAttribute('src') : '';
      if (!source) return;
      video.src = source;
    });
    return;
  }

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
  script.onload = function () {
    videos.forEach(video => {
      const sourceEl = video.querySelector('source');
      const source = sourceEl ? sourceEl.getAttribute('src') : '';
      if (!source) return;

      if (typeof Hls !== 'undefined' && Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(source);
        hls.attachMedia(video);
      } else {
        video.src = source;
      }
    });
  };
  document.head.appendChild(script);
});


document.addEventListener('DOMContentLoaded', function () {

// Attach Drift to the LINK itself, and tell it where the hi-res comes from:
Array.from(document.querySelectorAll('.drift-zoom-trigger')).map(el => {
    const inlinePaneThreshold = 768; // mimic Drift's internal mobile check (<=768px)
    const isMobile = window.innerWidth <= inlinePaneThreshold;

    new Drift(el, {
        sourceAttribute: 'data-zoom',
        paneContainer: el,
        inlinePane: false,
        zoomFactor: isMobile ? 2 : 1.2,
        showWhitespaceAtEdges: isMobile ? true : false,
    });
});

});


    let mediaFrame;

    $('#change-profile-photo').on('click', function (e) {
        e.preventDefault();

        if (mediaFrame) {
            mediaFrame.open();
            return;
        }

        mediaFrame = wp.media({
            title: 'Select profile photo',
            button: { text: 'Use this photo' },
            library: { type: 'image' },
            multiple: false
        });

        mediaFrame.on('select', function () {
            const attachment = mediaFrame
                .state()
                .get('selection')
                .first()
                .toJSON();

            $('#profile_avatar_id').val(attachment.id);

            // Optional: live preview
            $('.profile-avatar img').attr(
                'src',
                attachment.sizes.thumbnail.url
            );
        });

        mediaFrame.open();
    });




  document.addEventListener('DOMContentLoaded', () => { 
  const modalEl = document.querySelector('.mwm-auth-modal[data-auth-open="1"]');
  console.log('hello DOM');
  if (!modalEl || typeof UIkit === 'undefined') return;

  const tab = modalEl.getAttribute('data-auth-tab') || 'login';
  const tabIndex = (tab === 'register') ? 1 : 0;

  // Open modal
  UIkit.modal(modalEl).show();

  // Switch tab (needs to run after modal is shown)
  requestAnimationFrame(() => {
    const switcherEl = modalEl.querySelector('.uk-switcher');
    if (!switcherEl) return;

    const switcher = UIkit.switcher(switcherEl);
    if (switcher && typeof switcher.show === 'function') {
      switcher.show(tabIndex);
    }
  });

  console.log('showww')
});



    const runConfetti = () => {
        const confettiFn = window.confetti;
        if (typeof confettiFn !== "function") return;

        let positionList = [
            { x: window.innerWidth * 0.50, y: window.innerHeight * 0.60 },
            { x: window.innerWidth * 0.25, y: window.innerHeight * 0.40 },
            { x: window.innerWidth * 0.75, y: window.innerHeight * 0.30 },
        ];

        for (let i = 0; i < positionList.length; i++) {
            setTimeout(() => confettiFn({ position: positionList[i] }), i * 250);
        }
        console.log("Logging this?");
    };

    const bindFundraiserCompleteConfetti = () => {
        if (
            typeof UIkit === "undefined" ||
            typeof UIkit.util === "undefined" ||
            typeof UIkit.util.on !== "function"
        ) {
            return;
        }

        UIkit.util.on(".fundraiser-progress", "inview", (event) => {
            const progressEl = event && event.target
                ? event.target.closest(".fundraiser-progress")
                : null;

            if (!progressEl) return;
            if ((progressEl.getAttribute("data-status") || "").toLowerCase() !== "complete") return;
            if (progressEl.dataset.confettiTriggered === "1") return;

            progressEl.dataset.confettiTriggered = "1";
            runConfetti();
        });
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bindFundraiserCompleteConfetti, { once: true });
    } else {
        bindFundraiserCompleteConfetti();
    }

      document.addEventListener('DOMContentLoaded', () => { 
        if($('#fundraising-thankyou').length) {
           runConfetti();
        }
      });

/*
 * LIVE_20260318 (commented)
 * Live snapshot included event-map/HLS helpers not present in this branch.
 * Preserved here for manual opt-in without changing current runtime behavior.
 */
function hasNativeHls() {
  const v = document.createElement("video");
  const canPlay = v.canPlayType("application/vnd.apple.mpegurl");
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  return isSafari && canPlay;
}

function initCinnamonEventMaps() {
  document.querySelectorAll('.archive-map-instance').forEach(block => {
    const mapId = block.getAttribute('data-map-id');
    const jsonScript = document.getElementById(`map-data-${mapId}`);
    if (!jsonScript) return;

    let events;
    try {
      events = JSON.parse(jsonScript.textContent);
    } catch (err) {
      console.error('Invalid JSON for map:', err);
      return;
    }

    const initialCenter = { lat: 53.755, lng: -3.743 };
    const initialZoom = 6;
    const targetZoom = 9;

    const mapEl = block.querySelector('.event-archive-map');
    const sidebar = block.querySelector('.event-sidebar');
    const dropdown = block.querySelector('.event-dropdown');
    const goBtn = block.querySelector('.event-go-btn');
    const closeBtn = block.querySelector('.closeslide');

    const map = new google.maps.Map(mapEl, {
      zoom: initialZoom,
      center: initialCenter,
      styles: window.cinnamonMapStyles || [],
      disableDefaultUI: true,
      zoomControl: true,
      streetViewControl: true,
      scrollwheel: true
    });

    let activeMarker = null;

    function smoothZoom(mapRef, target, step = 150, callback) {
      let currentZoom = mapRef.getZoom();
      const increment = currentZoom < target ? 1 : -1;
      function zoomStep() {
        currentZoom += increment;
        mapRef.setZoom(currentZoom);
        if (currentZoom !== target) {
          setTimeout(zoomStep, step);
        } else if (callback) {
          callback();
        }
      }
      zoomStep();
    }

    function smoothZoomPan(newCenter, newZoom, reset = false) {
      if (reset) {
        smoothZoom(map, initialZoom, 150, () => map.panTo(initialCenter));
      } else {
        map.panTo(newCenter);
        smoothZoom(map, newZoom);
      }
    }

    events.forEach(data => {
      const marker = new google.maps.Marker({
        position: { lat: data.position.lat, lng: data.position.lng },
        map: map,
        icon: {
          url: data.icon,
          scaledSize: new google.maps.Size(40, 68)
        },
        title: data.title
      });

      marker.addListener('click', () => {
        if (sidebar.classList.contains('active') && activeMarker === marker) {
          sidebar.classList.remove('active');
          smoothZoomPan(initialCenter, initialZoom, true);
          activeMarker = null;
        } else {
          sidebar.querySelector('#event-title').innerText = data.title;
          sidebar.querySelector('#event-address').innerHTML = data.address;
          sidebar.querySelector('#event-link').href = data.link;
          sidebar.classList.add('active');
          smoothZoomPan(marker.getPosition(), targetZoom);
          activeMarker = marker;
        }
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        sidebar.classList.remove('active');
        smoothZoomPan(initialCenter, initialZoom, true);
        activeMarker = null;
      });
    }

    if (goBtn && dropdown) {
      goBtn.addEventListener('click', () => {
        const selected = dropdown.value;
        if (selected) window.location.href = selected;
      });
    }
  });
}
